export default "__VITE_ASSET__Bx3PwbwH__"